// src/pages/MainPage.jsx
import React, { useState } from 'react';
import { Box, ThemeProvider, CssBaseline } from '@mui/material';
import { darkTheme, lightTheme } from '../components/theme';
import NavBar from '../components/NavBar';
import IntroSection from '../components/IntroSection';
import Footer from '../components/Footer';
import ChatWindow from '../components/ChatWindow';
import BotIntro from '../components/BotIntro';

function MainPage() {
  const [isDarkMode, setIsDarkMode] = useState(true);  // 기본은 다크모드

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const theme = isDarkMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          backgroundColor: theme.palette.background.default,
          [theme.breakpoints.up('md')]: {
            scrollSnapType: 'y mandatory',
          },
        }}
      >
        <NavBar toggleTheme={toggleTheme} isDarkMode={isDarkMode} />

        <Box
          sx={{
            bgcolor: theme.palette.background.paper,
            minHeight: { xs: '70vh', sm: '90vh', md: '100vh' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.up('md')]: {
              scrollSnapAlign: 'start',
            },
          }}
        >
          <BotIntro />
        </Box>

        <Box
          sx={{
            bgcolor: theme.palette.background.default,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.up('md')]: {
              scrollSnapAlign: 'start',
            },
          }}
        >
          <ChatWindow />
        </Box>

        <Box
          sx={{
            minHeight: '100vh',
            bgcolor: theme.palette.background.paper,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.up('md')]: {
              scrollSnapAlign: 'start',
            },
          }}
        >
          <IntroSection />
        </Box>

        <Box
          sx={{
            bgcolor: theme.palette.background.default,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.up('md')]: {
              scrollSnapAlign: 'start',
            },
          }}
        >
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default MainPage;
